import { useEffect } from "react";
import ReactGA from "react-ga4";

import { GOOGLE_PROJECT_ID } from "~/constants/analytics";

export const GoogleAnalytics = () => {
  useEffect(() => {
    if (GOOGLE_PROJECT_ID) {
      ReactGA.initialize(GOOGLE_PROJECT_ID);
    }
  }, []);

  return null;
};
